export default "__VITE_ASSET__CfL84$r1__"